import { z } from "zod";
import { metaEventContextSchema } from "./analytics";

export const addPaymentMethodSchema = z.object({
  paymentMethodId: z.string(),
});

export const createWalletPaymentMethodSchema = z.object({
  token: z.string().min(1, "Token is required"),
  type: z.enum(["apple_pay", "google_pay"], {
    errorMap: () => ({ message: "Type must be either apple_pay or google_pay" }),
  }),
});

export const validateDiscountCodeSchema = z.object({
  code: z.string().min(1, "Discount code is required"),
});

export const createSubscriptionSchema = z.object({
  lookupKey: z.string().min(1, "Lookup key is required"),
  couponCode: z.string().optional(),
  companyName: z.string().min(1).optional(),
  vatNumber: z.string().min(2).optional(),
  paymentMethodId: z.string().optional(),
  meta: metaEventContextSchema.optional(),
});

export const createRefundRequestSchema = z.object({
  invoiceId: z.string().min(1, "Invoice ID is required"),
  reasonCategory: z.enum([
    "not_satisfied",
    "technical_issue",
    "billing_error",
    "duplicate_charge",
    "other",
  ]),
  reasonDetails: z.string().max(500, "Details must be less than 500 characters").optional(),
});

export const updateSubscriptionSchema = z.object({
  lookupKey: z.string().min(1, "Lookup key is required"),
});

export const previewSubscriptionChangeSchema = z.object({
  lookupKey: z.string().min(1, "Lookup key is required"),
});

export type AddPaymentMethodRequest = z.infer<typeof addPaymentMethodSchema>;
export type CreateWalletPaymentMethodRequest = z.infer<typeof createWalletPaymentMethodSchema>;
export type ValidateDiscountCodeRequest = z.infer<typeof validateDiscountCodeSchema>;
export type CreateSubscriptionRequest = z.infer<typeof createSubscriptionSchema>;
export type CreateRefundRequest = z.infer<typeof createRefundRequestSchema>;
export type UpdateSubscriptionRequest = z.infer<typeof updateSubscriptionSchema>;
export type PreviewSubscriptionChangeRequest = z.infer<typeof previewSubscriptionChangeSchema>;
